import React, { useContext, useEffect } from "react";
import { Button, Input, notification, Form } from "antd";
import GlobalContext from "../utils/GlobalContext";
import "moment-timezone";
import axios from "axios";

const System = () => {
  const globals = useContext(GlobalContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${globals.SERVICE_API_DB}/v1/consult-general-config`,
          {
            headers: {
              "x-token": globals.token,
            },
          }
        );
        const result = res.data;
        form.setFieldsValue({
          group_name: result?.data[0]?.group_name,
        });
      }
      catch (err) {
        console.log(err);
        notification.error({
          message: "Error al cargar la configuración",
          placement: "bottomRight",
          duration: 2,
        });
      } 
    }
    fetchData();
    // eslint-disable-next-line
  }, []);


  const handleChangeAdminGroup = async (values) => {

    try{
      const res = await axios.put(`${globals.SERVICE_API_DB}/v1/update-general_config/${1}`,
        values,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      const result = res.data;
      console.log(result);
      if (result.status === 0) {
        notification.success({
          message: "Grupo actualizado exitosamente!",
          placement: "bottomRight",
          duration: 2,
        });
      } else {
        notification.error({
          message: "Error al actualizar el grupo",
          placement: "bottomRight",
          duration: 2,
        });
        
        return;
      }
    }
    catch(err) {
      console.log(err.response);
      notification.error({
        message: "Error al actualizar el grupo",
        placement: "bottomRight",
        duration: 2,
      });            
    }

  };

  const [form] = Form.useForm();

  const TitleBar = () => (
    <div
      style={{ display: "flex", alignItems: "center", marginBottom: "0px" }}
    >
      <h2 style={{ marginRight: "16px" }}>Ajustes del sistema</h2>
      <div style={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
    </div>
  );

  return (
    <div style={{ padding: "24px" }}>
      <TitleBar />
      <div>
        <h3 style={{ marginBottom: "16px" }}>Grupo de administradores</h3>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleChangeAdminGroup}
        >
          <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
          <Form.Item
              label="Grupo de administradores"
              name="group_name"
              rules={[
                { required: true, message: "Este campo es requerido" },
                { type: 'email', message: "Ingrese un grupo válido" },
              ]}
            >
            <Input style={{ width: "300px" }} />
          </Form.Item>
          <Button type="primary" htmlType="submit" style={{ marginLeft:"16px", width: "100px" }}>Cambiar</Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default System;
